import { DateRange } from "react-day-picker";
import api from "./baseApi";
import { AxiosError } from "axios";

export const addCollectiOnorder = async (collectionorder: any) => {
  try {
    const response = await api.post("/collection", collectionorder);
    return response;
  } catch (error: any) {
    throw new Error(error.response.data.message);
  }
};

export const getTransactions = async (collectionorderId: string) => {
  try {
    const response = await api.get(
      `/collector/orders/${collectionorderId}/transactions`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching collectionorder", error);
  }
};

export const getCollectionOrders = async ({
  page = 1,
  perPage = 10,
  searchTerm,
  selectedWilaya,
  status,
  selectedCollector,
  dateRange,
}: {
  page?: number;
  perPage?: number;
  searchTerm?: string;
  selectedWilaya?: string;
  status?: string;
  selectedCollector?: string;
  dateRange?: DateRange | undefined;
}) => {
  try {
    let query = `?page=${page}&perPage=${perPage}`;
    if (searchTerm) query += `&fullname=${searchTerm}`;
    if (selectedWilaya) query += `&wilaya=${selectedWilaya}`;
    if (status) query += `&status=${status}`;
    if (selectedCollector) query += `&collectorId=${selectedCollector}`;
    if (dateRange?.from) query += `&startDate=${dateRange.from.toISOString()}`;
    if (dateRange?.to) {
      const endDate = new Date(dateRange.to);
      endDate.setDate(endDate.getDate() + 1); // Add one day to the end date
      query += `&endDate=${endDate.toISOString()}`;
    }

    console.log(query);
    const response = await api.get(`/collection${query}`);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      // Detailed Axios error information
      console.error("Error fetching collection orders:", {
        message: error.message,
        code: error.code,
        response: error.response?.data || "No response data",
        status: error.response?.status,
        stack: error.stack,
      });
    } else {
      // General error logging
      console.error("Unexpected error:", error);
    }

    // Optionally, return specific error data
    return {
      success: false,
      error:
        error instanceof AxiosError
          ? error.response?.data || error.message
          : "An unexpected error occurred.",
    };
  }
};

export const getCollectionOrderById = async (collectionorderId: string) => {
  try {
    const response = await api.get(`/collection/${collectionorderId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching collectionorder", error);
  }
};

export const deleteCollectionorderApi = async (collectionorderId: string) => {
  try {
    const response = await api.delete(`/collection/${collectionorderId}`);
    return response;
  } catch (error) {
    console.error("Error deleting collectionorder", error);
  }
};

export const updateCollectionorderApi = async (
  collectionorderId: string,
  collectionorder: any
) => {
  console.log(collectionorder, collectionorderId);
  try {
    const response = await api.patch(
      `/collection/${collectionorderId}`,
      collectionorder
    );
    return response;
  } catch (error) {
    console.error("Error updating collectionorder", error);
  }
};

export const exportCollectionOrders = async () => {
  try {
    const response = await api.get("/collection/export-csv");
    return response.data;
  } catch (error) {
    console.error("Error exporting collectionorders", error);
  }
};
